// extracted by mini-css-extract-plugin
module.exports = {"loader":"styles_loader__3S6QN","cardHeader":"styles_cardHeader__1ITLL","buttons":"styles_buttons__OSMLi"};